import * as React from 'react';
import header1 from '../../assets/images/header1.jpg';
import styled from '@emotion/styled';

const Header = styled('div')(({ theme }) => ({
  backgroundImage: `url(${header1})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100%',
  backgroundColor: 'tertiary.extraLight',
  [theme.breakpoints.down('md')]: {
    minHeight: '15vh',
  },
  [theme.breakpoints.up('md')]: {
    minHeight: '20vh',
  },
  [theme.breakpoints.up('lg')]: {
    minHeight: '28vh',
  },
  [theme.breakpoints.up('xl')]: {
    minHeight: '35vh',
  },
}));

export default function HeaderImage(props) {
  return <Header />;
}
